import stringifyGraphQlVars from 'src/internal/prefetching/stringifyGraphQlVars';
import {generateHashForDocument} from 'src/internal/revamp/queryUtils/documentHashing';

import type {DocumentNode} from 'graphql';
import type {OperationVariables} from 'src/internal/revamp/graphql/types';

export function buildQueryAndVariablesHash(
  document: DocumentNode,
  variables: OperationVariables | undefined,
): {
  documentHash: string;
  documentHashWithVariables: string;
} {
  const documentHash = generateHashForDocument(document);
  const documentHashWithVariables = concatenateQueryHashWithVariablesHash(
    documentHash,
    variables,
  );

  return {
    documentHash,
    documentHashWithVariables,
  };
}

export function concatenateQueryHashWithVariablesHash(
  documentHash: string,
  variables: Record<string, any> | undefined,
): string {
  const stableStringifiedVariables = stringifyGraphQlVars(variables || {});

  return `${documentHash}#${stableStringifiedVariables}`;
}
